import { useLayoutEffect } from "react";
import useTrackHeight from "@/utils/use-track-height";

interface ISetBannerHeightProps {
	element: HTMLDivElement | null;
	hasAnnouncements: boolean;
}

const useSetBannerHeight = ({ element, hasAnnouncements }: ISetBannerHeightProps) => {
	// offsetHeight is border-box layout px - it includes padding/border and any explicitly set
	// height, and is unaffected by the editor's transform: scale(), unlike getBoundingClientRect()
	const { height: bannerHeight } = useTrackHeight({
		ref: element,
		trackOnResize: true,
		trackOffsetHeight: true,
		skipTrackOnMutate: true,
	});

	// The banner height has to be set at the global level  because of how the event page is nested together.
	// but because the banner and the player are siblings we need the scope of the variable to be for the  whole page.
	useLayoutEffect(() => {
		if (element) {
			const height = bannerHeight <= 1 || !hasAnnouncements ? '0px' : `${bannerHeight}px`;
			document.documentElement.style.setProperty('--banner-height', height);
		}
		// reset to zero on unmount, because this hook is called within announcements-v2.tsx which means
		// if it's unmounted there are no announcements and we must reset the height to zero to reposition the navbar correctly
		return () => {
			// Note: must be `0px` not `0` or it will do funky things
			document.documentElement.style.setProperty('--banner-height', '0px');
		};
	}, [bannerHeight, element, hasAnnouncements]);
};

export default useSetBannerHeight;
